export const adminPermission = {
  funelCardAction: true,
};
